import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import ClassNames from 'classnames'
import _ from 'lodash'
import Bus from '../utils/bus'
let BUS = new Bus()
import IntroSubsection from '../home/intro-subsection'
import Benefits from '../home/benefits'
import ExplainerVideo from '../home/explainer-video'
import CTA from '../home/cta'
import FAQs from '../home/faqs'
import Ingredients from '../home/ingredients'
import Intro from '../home/intro'
import Press from '../home/press'
import SuperchargeHome from '../home/supercharge-cta-home'
import Purpose from '../home/purpose'
import TestimonialsMobile from '../home/testimonials-mobile'
import TestimonialsDesktop from '../home/testimonials-desktop'
import Using from '../home/using'
import NutritionalModal from '../components/page/nutritional-modal'
import { HelmetDatoCms } from 'gatsby-source-datocms'

class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.renderSlice = this.renderSlice.bind(this);
  }

  renderSlice(slice, index) {
    switch (slice["__typename"]) {
      case "DatoCmsSpread":
        return <Spread data={slice} index={index} key={index} url={"/"} />;
      case "DatoCmsIngredientsBlock":
        return <Ingredients key={index} data={slice} />;
      case "DatoCmsComparisonTable":
        return <Comparison key={index} data={slice} />;
      default:
        return null;
    }
  }

  render() {
    let homepage = this.props.data.homepage.edges[0].node
    let ingredients = this.props.data.ingredients.edges
    let TData = this.props.data.testimonials.edges

    return (
      <div className="App">
        <HelmetDatoCms seo={homepage.seoMetaTags} />
        <Intro
          intro={homepage.intro}
          callToAction={homepage.introCallToAction}
        />
        <Ingredients
          ingredientsTitle={homepage.ingredientsTitle}
          ingredientsSubtext={homepage.ingredientsSubtext}
          ingredientsPretitle={homepage.ingredientsPretitle}
          ingredients={ingredients}
        />
        <ExplainerVideo
          data={{
            title: homepage.brookesStoryTitle,
            copy: homepage.brookesStoryCopy,
            video: homepage.brookesStoryVideo,
            image: homepage.brookesStoryImage.url
          }}
        />
        <Press items={homepage.press} />
        <SuperchargeHome
          title={homepage.superchargeTitle}
          callToActionLink={"/buy"}
          callToAction={homepage.introCallToAction}
        />
        <FAQs data={homepage.faqBlock} />
        <div className="purpose-cta-container">
          <Purpose
            data={{
              copy: homepage.ourSocialPurpose
            }}
          />
          <CTA
            title={homepage.ospTitle}
            callToAction={homepage.callToAction}
            callToActionLink={homepage.callToActionLink}
          />
        </div>
        <NutritionalModal data={homepage.nutritionalInfo} />
      </div>
    );
  }
}

export default Homepage;

Homepage.propTypes = {
  data: PropTypes.shape({
    homepage: PropTypes.object.isRequired
  }).isRequired
};

/* eslint no-undef: "off" */

//
export const query = graphql`
  query HomepageQyery {
    homepage: allDatoCmsHomepage {
      edges {
        node {
          intro
          introCallToAction
          introSubsectionText
          introTestimonialPhoto {
            url
            title
            alt
          }
          introTestimonialName
          introTestimonialQuote
          introTestimonialText
          press {
            ... on DatoCmsLogo {
              url
              image {
                url
              }
              pressQuote
            }
          }
          solvingTheProblem
          benefitsTitle
          benefitsSubtitle
          benefitsImagery {
            ... on DatoCmsBenefitBlock {
              text
              subtext
              image {
                url
              }
            }
          }
          benefitsOutro
          nutritionalInfo {
            fluid {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          ingredientsTitle
          ingredientsSubtext
          ingredientsPretitle
          superchargeTitle
          brookesStoryTitle
          brookesStoryCopy
          brookesStoryVideo {
            url
            title
            width
            height
            provider
            providerUid
            thumbnailUrl
          }
          brookesStoryImage {
            url
          }
          faqBlock {
            ... on DatoCmsBlock {
              question
              answer
            }
          }
          ourSocialPurpose
          ospTitle
          callToAction
          callToActionLink
          seoMetaTags {
            ...GatsbyDatoCmsSeoMetaTags
          }
        }
      }
    }

    ingredients: allDatoCmsIngredient(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          name
          subName
          description
          descriptionExtended
          image {
            fluid(
              maxWidth: 450
              imgixParams: { fm: "jpg", auto: "compress" }
            ) {
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          origin
        }
      }
    }

    testimonials: allDatoCmsSocialTestimonial(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          name
          username
          image {
            id
            url
            fluid {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          text
          avatar {
            id
            url
            fluid {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
          linksTo
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/index.js